module.exports = __webpack_public_path__ + "static/img/karticekorisnikaprint.821fdd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/karticekorisnikaprint.png
// module id = vP1i
// module chunks = 0